import React, { useEffect, useState } from 'react';
import { useCartContext } from '../../Contexts/CartContext';
import { TbArrowBearRight, TbClockCheck, TbMoodSearch, TbSend, TbShoppingBagPlus } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';

const StepsStoreCounter = () => {

    const { t } = useTranslation();
    const { cartDisplay } = useCartContext();
    const [showStep1, setShowStep1] = useState<boolean>(false)
    const [showStep2, setShowStep2] = useState<boolean>(false)
    const [showStep3, setShowStep3] = useState<boolean>(false)
    const [showStep4, setShowStep4] = useState<boolean>(false)

    useEffect(() => {
        const totalSteps = 4;
        let currentStep = 1;
        const interval = setInterval(() => {
            if (currentStep <= totalSteps) {
                if (currentStep === 1) setShowStep1(true);
                if (currentStep === 2) setShowStep2(true);
                if (currentStep === 3) setShowStep3(true);
                if (currentStep === 4) setShowStep4(true);
                currentStep++;
            } else {
                clearInterval(interval);
            }
        }, 500);
        return () => {
            clearInterval(interval);
        }
    }, []);

    return (
        <div className='flex gap-1 text-sm text-gray-500 p-2 py-6 w-full'>
          {!cartDisplay &&
              <div className={`relative w-full max-w-24 flex flex-col gap-2 items-center justify-center w-full transition ${showStep1 ? 'opacity-100' : 'opacity-0' }`}>
                  <TbArrowBearRight size={cartDisplay ? 30 : 20} className='absolute -top-4 -right-2 rotate-90 text-gray-200' />
                  <div><TbMoodSearch size={30} /></div>
                  <span className='h-full leading-4'>{t('store_counter.welcome.steps.open.title')}</span>
              </div>
          }
          <div className={`relative w-full max-w-24 flex flex-col gap-2 items-center justify-center w-full transition ${showStep2 ? 'opacity-100' : 'opacity-0' }`}>
              <TbArrowBearRight size={cartDisplay ? 30 : 20} className='absolute -top-4 -right-2 rotate-90 text-gray-200' />
              <div><TbShoppingBagPlus size={30} /></div>
              <span className='h-full leading-4'>{t('store_counter.welcome.steps.add_products.title')}</span>
          </div>
          <div className={`relative w-full max-w-24 flex flex-col gap-2 items-center justify-center w-full transition ${showStep3 ? 'opacity-100' : 'opacity-0' }`}>
              <TbArrowBearRight size={cartDisplay ? 30 : 20} className='absolute -top-4 -right-4 rotate-90 text-gray-200' />
              <div><TbSend size={30} /></div>
              <span className='h-full leading-4'>
                  {cartDisplay 
                      ? <>{t('store_counter.welcome.steps.check_and_send.title')}</>
                      : <>{t('store_counter.welcome.steps.send.title')}</>
                  }
              </span>
          </div>
          <div className={`w-full max-w-24 flex flex-col gap-2 items-center justify-center w-full transition ${showStep4 ? 'opacity-100' : 'opacity-0' }`}>
              <div><TbClockCheck size={30} /></div>
              <span className='h-full leading-4'>
                  {cartDisplay 
                      ? t('store_counter.welcome.steps.wait_with_cart.title')
                      : t('store_counter.welcome.steps.wait.title')
                  }
              </span>
          </div>
      </div>
    )
}

export default StepsStoreCounter;
